import { __assign, __makeTemplateObject, __rest } from "tslib";
import { Popper } from '@material-ui/core';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Paper } from '../Paper/Paper';
import { getFixedSpacing } from '../../theme/Spacing/Spacing';
export var AutocompleteList = forwardRef(function (props, ref) {
    var anchorEl = props.anchorEl, open = props.open, htmlAttributes = __rest(props, ["anchorEl", "open"]);
    return (React.createElement(SPopper, __assign({ open: open, anchorEl: anchorEl, ref: ref }, htmlAttributes),
        React.createElement(SItemContainer, { style: {
                width: (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.clientWidth) || 0, // NOSONAR
            } }, props.children)));
});
var SPopper = styled(Popper).attrs({ disablePortal: true })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var SItemContainer = styled(Paper).attrs({ square: true })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: 50vh;\n  overflow: auto;\n  padding: ", "px 0;\n  margin-top: ", "px;\n"], ["\n  max-height: 50vh;\n  overflow: auto;\n  padding: ", "px 0;\n  margin-top: ", "px;\n"])), getFixedSpacing(1), getFixedSpacing(0.5));
var templateObject_1, templateObject_2;
//# sourceMappingURL=AutocompleteList.js.map